import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut, sendEmailVerification } from 'firebase/auth';
import { getStorage, ref as sRef, uploadBytesResumable } from 'firebase/storage';
import { getFirestore, collection, doc, onSnapshot, setDoc, query, orderBy, limit, where, getDocs, updateDoc, arrayUnion, deleteDoc, arrayRemove, startAfter } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';
import esTranslation from './locales/es/translation.json';

import './css/style.css';
import './css/all.min.css';
import './css/v4-shims.min.css';

const app = initializeApp({
    apiKey: "AIzaSyBzQubp8v2ais9gVcf_GCsvdGqs7CduaDk",
    authDomain: "fiveloop-9efa7.firebaseapp.com",
    databaseURL: "https://fiveloop-9efa7-default-rtdb.firebaseio.com",
    projectId: "fiveloop-9efa7",
    storageBucket: "fiveloop-9efa7.appspot.com",
    messagingSenderId: "209102879062",
    appId: "1:209102879062:web:4e5c724e72834cf885fef7"
});


document.addEventListener('DOMContentLoaded', function() {
  setupi18n()
});

async function setupi18n(){
  await i18n
  .use(LanguageDetector) // Detects user language
  .init({
    fallbackLng: 'en',
    resources: {
      en: {
        translation: enTranslation
      },
      de: {
        translation: deTranslation
      },
      fr: {
        translation: frTranslation
      },
      es: {
        translation: esTranslation
      }
    }
  });

  $('.txtUploadBtn').html(i18n.t('stringUploadSong'));
  $('.txtAddPlaylistBtn').html(i18n.t('stringAddPlaylist'));
  $('.txtAllSongsBtn').html(i18n.t('stringAllSongs'));
  $(".txtSearchSong").attr("placeholder", i18n.t('stringSearchSong'));
  $('.txtUploadNow').html(i18n.t('stringUploadNow'));
  $('.txtDragFileDesc').html(i18n.t('stringDragFileDesc'));
  $('.txtSupportedFormats').html(i18n.t('stringSupportedFormats'));
  $('.txtRename').html(i18n.t('stringRename'));
  $('.txtRemove').html(i18n.t('stringRemove'));
  $('.txtVerificationModalHeader').html(i18n.t('stringVerificationModalHeader'));
  $('.txtVerificationModalText').html(i18n.t('stringVerificationModalText'));
  $('.txtStemSeparationModel').text(i18n.t('stringStemSeparationModel'));
  $('.txtSixStems').text(i18n.t('stringSixStems'));
  $('.txtSixStemList').text(i18n.t('stringSixStemList'));
  $('.txtFourStems').text(i18n.t('stringFourStems'));
  $('.txtFourStemList').text(i18n.t('stringFourStemList'));
  $('.native-stem-model-picker').attr('aria-label', i18n.t('stringStemSeparationModel'));
  $('.txtSendEmailAgain').html(i18n.t('stringSendEmailAgain'));
  $('.txtLogout').html(i18n.t('stringLogout'));
  $('.txtNewPlaylist').html(i18n.t('stringNewPlaylist'));
  $('.txtCreatePlaylist').html(i18n.t('stringCreatePlaylist'));
  $('.txtRenameSong').html(i18n.t('stringRenameSong'));
  $('.txtRenameNow').html(i18n.t('stringRenameNow'));
  $('.txtRenamePlaylist').html(i18n.t('stringRenamePlaylist'));
  $('.txtGetPremium').html(i18n.t('stringGetPremium'));
  $('.txtGetPremiumDetailTwoSongs').html(i18n.t('stringGetPremiumDetailTwoSongs'));
  $('.txtPremiumInfo').html(i18n.t('stringPremiumInfo'));
  $('.txtFiftySongsLimit').html(i18n.t('stringFiftySongsLimit'));
  $('.txtFiftySongsLimitDetail').html(i18n.t('stringFiftySongsLimitDetail'));
  $('.txtFairUseWarningTitle').html(i18n.t('stringFairUseWarningTitle'));
  
}


const auth = getAuth(app);
//const database = getDatabase(app);
const storage = getStorage(app);
const db = getFirestore(app);
const functions = getFunctions(app);

const FIVELOOP_NATIVE_SERVER = 'http://127.0.0.1:54322';
const FIVELOOP_NATIVE_API_VERSION = 1;
const FIVELOOP_NATIVE_UPLOAD_MODEL = 'htdemucs_6s';
const FIVELOOP_NATIVE_LAUNCH_POLL_INTERVAL_MS = 2000;
const FIVELOOP_NATIVE_LAUNCH_POLL_TIMEOUT_MS = 90000;
let nativeFiveLoopLaunchPollId = 0;

function stopNativeFiveLoopLaunchPolling() {
  nativeFiveLoopLaunchPollId += 1;
}

const resultsPerPage = 10

const indexedDB =
  window.indexedDB ||
  window.mozIndexedDB ||
  window.webkitIndexedDB ||
  window.msIndexedDB ||
  window.shimIndexedDB;

if (!indexedDB) {
  console.log("IndexedDB could not be found in this browser.");
}

//MARK: User Authentication

var userId = ""

onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    userId = user.uid
    if (user.emailVerified) {
      document.getElementById("userContainer").style.display="inline"
      document.getElementById("navbarUsername").innerHTML = user.email
      songListener()
      playlistListener()
      userHasPremiumCustomClaim().then((hasPremium) => {
        if (hasPremium) {
          document.getElementById("navbarPremiumTag").innerHTML = "Premium"
        } else {
          document.getElementById("premiumInfoBtn").classList.remove("hidedisplay")
        }
        document.getElementById("navbarUsersettings").classList.remove('hide')
      });
      
    } else {
      toggleModal2()
    }
    
  } else {
    // User is signed out
    window.location.replace("login.html");
  }
});

async function userHasPremiumCustomClaim() {
  await auth.currentUser.getIdToken(true); // Force refresh to get the latest tokens
  const decodedToken = await auth.currentUser.getIdTokenResult();
  const stripeRole = decodedToken.claims.stripeRole;
  const lemonSqueezyRole = decodedToken.claims.lemonSqueezyRole;
  const revenueCatEntitlements = decodedToken.claims.revenueCatEntitlements;
  // Check if stripeRole is premium
  const hasPremiumStripeRole = stripeRole === "premium";
  // Check if lemonSqueezyRole is premium
  const hasPremiumLemonSqueezyRole = lemonSqueezyRole === "premium";
  // Check if revenueCatEntitlements contains "Premium"
  const hasPremiumRevenueCat = revenueCatEntitlements && revenueCatEntitlements.includes("Premium");
  // Return true if either condition is met
  return hasPremiumStripeRole || hasPremiumLemonSqueezyRole || hasPremiumRevenueCat;
}

$("#loginBtn").click(function(){
  var email = document.getElementById("inputAccountEmail").value
  var password = document.getElementById("inputPassword").value

  signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      // ...
    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
      alert(error.message)
    });
});

$(document).on('click', '#logoutBtn', function() {
  signOut(auth).then(() => {
    // Sign-out successful.
  }).catch((error) => {
    // An error happened.
    alert(error)
  });
});

$("#logoutBtnModal").click(function(){
  signOut(auth).then(() => {
    // Sign-out successful.
  }).catch((error) => {
    // An error happened.
    alert(error)
  });
});

$("#resendVerificationBtn").click(function(){
  sendEmailVerification(auth.currentUser)
    .then(() => {
      document.getElementById("verificationModalHeader").textContent = i18n.t('stringEmailSent')
      document.getElementById("verificationModalText").innerHTML = i18n.t('stringVerificationEmailResent')
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      alert(error.code)
    });
});

//MARK: Upload Song

// Get the modal
var modal2 = document.getElementById("myModal2");
function toggleModal2() {
  modal2.style.display = "block";
}

// Get the modal
var modal = document.getElementById("myModal");
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];
// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  closeModal()
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    closeModal()
  }
  if (event.target == modal3) {
    closeModal3()
  }
  if (event.target == modal4) {
    closeModal4()
  }
  if (event.target == modal5) {
    closeModal5()
  }
  if (event.target == modal6) {
    closeModal6()
  }
}
function closeModal(){
  stopNativeFiveLoopLaunchPolling();
  modal.style.display = "none";
}
function toggleModal() {
  resetUploadModal()
  modal.style.display = "block";
}

document.getElementById('uploadBtn').addEventListener("click", toggleModal);

function uploadFile() {
  //modal.style.display = "none";
  document.getElementById('file').click();
}

$(document).ready(function(){
  document.getElementById('file').addEventListener('change', handleFileSelect, false);
});

const dropZone = document.getElementById("drop-zone");

var dropzonecounter = 0

dropZone.addEventListener("click", uploadFile);

dropZone.addEventListener("dragover", function(event) {
  // Prevent the default behavior (open as link for some elements)
  event.preventDefault();
});

dropZone.addEventListener("dragenter", function(event) {
  const olddropable = document.querySelector(".drop-zone-readyfordrop")
  if (olddropable !== null){
    olddropable.classList.remove("drop-zone-readyfordrop")
  }
  dropZone.classList.add("drop-zone-readyfordrop")
  dropzonecounter++
});

dropZone.addEventListener("dragleave", function(event) {
  dropzonecounter--
  if(dropzonecounter === 0){
    dropZone.classList.remove("drop-zone-readyfordrop")
  }
});


dropZone.addEventListener("drop", function(event) {
  // Prevent the default behavior (open as link for some elements)
  dropzonecounter = 0
  dropZone.classList.remove("drop-zone-readyfordrop")

  event.preventDefault();

  // Get the dropped file
  const file = event.dataTransfer.files[0];

  // Do something with the file
  handleFile(file);
});




var newSongId = ""

// upload song to firebase storage
function handleFileSelect(evt) {

  var files = evt.target.files; // FileList object
  // files is a FileList of File objects. List some properties.
  var f = files[0]
  handleFile(f)

}


// upload song to firebase storage
function handleFile(f) {

    $("#file-upload-feedback").find("span").html('')

    const fileEnding = supportedUploadFileEnding(f);
    if(fileEnding == ""){
        $("#file-upload-feedback").find("span").text(i18n.t('stringIncompatibleFileFormat', { type: f.type }))
        return
    }

    const fileSizeInMB = (f.size / 1024 / 1024).toFixed(2);
    const audio = new Audio();
    audio.src = URL.createObjectURL(f);
    audio.addEventListener('loadedmetadata', function() {
      const minutes = Math.floor(audio.duration / 60);
      const seconds = Math.floor(audio.duration % 60);
      $("#drop-zone").addClass('hidedisplay');
      $("#drop-zone-filename").find("span").html(f.name)
      if (minutes > 13){
        $("#drop-zone-filemetadata").find("span").html(`Duration: <span style="color: #FF0000">${minutes}:${seconds}min (max. 12)</span> &nbsp; &nbsp; &nbsp; Size: ${fileSizeInMB}MB`)
        $("#drop-zone-occupied").removeClass('hidedisplay');
        $("#confirmUploadSong").addClass('hidedisplay');
      } else if (fileSizeInMB > 200) {
        $("#drop-zone-filemetadata").find("span").html(`Duration: ${minutes}:${seconds} &nbsp; &nbsp; &nbsp; Size: <span style="color: #FF0000">${fileSizeInMB}MB (max. 200)</span>`)
        $("#drop-zone-occupied").removeClass('hidedisplay');
        $("#confirmUploadSong").addClass('hidedisplay');
      } else {
        $("#drop-zone-filemetadata").find("span").html(`Duration: ${minutes}:${seconds} &nbsp; &nbsp; &nbsp; Size: ${fileSizeInMB}MB`)
        $("#drop-zone-occupied").removeClass('hidedisplay');
        $("#confirmUploadSong").removeClass('hidedisplay');
        fileToUpload = f
        fileEndingToUpload = fileEnding
      }
      
    });

  };

  function supportedUploadFileEnding(file) {
    const type = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();
    const extensionMatch = name.match(/\.[^.]+$/);
    const extension = extensionMatch ? extensionMatch[0] : '';
    const supportedExtensions = ['.mp3', '.wav', '.flac', '.aiff', '.aif', '.wma', '.m4a', '.mp4', '.mov'];
    const mimeToExtension = {
      'audio/mpeg': '.mp3',
      'audio/mp3': '.mp3',
      'audio/wav': '.wav',
      'audio/x-wav': '.wav',
      'audio/vnd.wave': '.wav',
      'audio/flac': '.flac',
      'audio/x-flac': '.flac',
      'audio/aiff': '.aiff',
      'audio/x-aiff': '.aiff',
      'audio/ms-wma': '.wma',
      'audio/x-ms-wma': '.wma',
      'audio/m4a': '.m4a',
      'audio/x-m4a': '.m4a',
      'audio/mp4': '.m4a',
      'video/mp4': extension === '.m4a' ? '.m4a' : '.mp4',
      'video/quicktime': '.mov'
    };

    if (mimeToExtension[type]) return mimeToExtension[type];
    return supportedExtensions.includes(extension) ? extension : '';
  }

  var fileToUpload = null
  var fileEndingToUpload = ""

  function selectedNativeStemModel() {
    const selected = document.querySelector('input[name="nativeStemModel"]:checked');
    return selected && selected.value ? selected.value : FIVELOOP_NATIVE_UPLOAD_MODEL;
  }

  function detectFiveLoopDesktopOS() {
    var platform = '';
    try {
      if (navigator.userAgentData && navigator.userAgentData.platform) {
        platform = String(navigator.userAgentData.platform);
      }
    } catch (err) {}
    platform = (platform || navigator.platform || navigator.userAgent || '').toLowerCase();
    if (platform.indexOf('mac') !== -1) return 'mac';
    if (platform.indexOf('win') !== -1) return 'windows';
    return 'other';
  }

  function fiveLoopOpenURLForCurrentOS() {
    return detectFiveLoopDesktopOS() === 'mac' ? 'fiveloop-helper://open' : 'fiveloop://open';
  }

  function fiveLoopDownloadURLForCurrentOS() {
    if (detectFiveLoopDesktopOS() === 'mac') {
      return 'https://apps.apple.com/de/app/video-foot-control/id1523186071';
    }
    return 'https://apps.microsoft.com/detail/9P34XJWVWM7D';
  }

  function fiveLoopDownloadLabelForCurrentOS() {
    return detectFiveLoopDesktopOS() === 'mac'
      ? i18n.t('stringDownloadFiveLoopMac')
      : i18n.t('stringDownloadFiveLoop');
  }

  function openFiveLoopExternalURL(url) {
    if (!url) return;
    try {
      const link = document.createElement('a');
      link.href = url;
      link.style.display = 'none';
      document.documentElement.appendChild(link);
      link.click();
      setTimeout(function () {
        if (link.parentNode) link.parentNode.removeChild(link);
      }, 0);
    } catch (err) {
      try { window.location.href = url; } catch (fallbackErr) {}
    }
  }

  async function checkNativeFiveLoopServer() {
    const controller = new AbortController();
    const timeout = setTimeout(function () { controller.abort(); }, 1500);
    try {
      const response = await fetch(FIVELOOP_NATIVE_SERVER + '/cloud-song/health', {
        method: 'GET',
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) return { available: false, busy: false };
      const health = await response.json();
      const available = health && health.ready === true && health.supportsCloudSongProcessing === true &&
        Number(health.nativeApiVersion || 0) >= FIVELOOP_NATIVE_API_VERSION;
      return {
        available: available,
        busy: available && health.busy === true,
        activePhase: health && health.activePhase ? String(health.activePhase) : ''
      };
    } catch (err) {
      return { available: false, busy: false };
    } finally {
      clearTimeout(timeout);
    }
  }

  function setUploadSongSelectionStepVisible(visible) {
    $('.upload-song-selection-step').toggleClass('hidedisplay', !visible);
  }

  function showNativeUploadBusyMessage(nativeStatus) {
    const activePhase = nativeStatus && nativeStatus.activePhase ? nativeStatus.activePhase : '';
    const title = activePhase
      ? i18n.t('stringFiveLoopBusyWithPhase', { phase: activePhase })
      : i18n.t('stringFiveLoopBusy');
    setUploadSongSelectionStepVisible(false);
    $("#file-upload-feedback").find("span").html(
      '<div class="native-upload-unavailable-card">' +
        '<strong>' + title + '</strong>' +
        '<p>' + i18n.t('stringFiveLoopBusyDetail') + '</p>' +
      '</div>'
    );
  }

  async function fetchNativeFiveLoopAccountStatus() {
    const controller = new AbortController();
    const timeout = setTimeout(function () { controller.abort(); }, 5000);
    try {
      const response = await fetch(FIVELOOP_NATIVE_SERVER + '/account/status?t=' + Date.now(), {
        method: 'GET',
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) throw new Error(i18n.t('stringFiveLoopAccountUnavailable'));
      return await response.json();
    } finally {
      clearTimeout(timeout);
    }
  }

  async function assertNativeFiveLoopAccountMatchesBrowser() {
    const browserUser = auth.currentUser;
    if (!browserUser || !browserUser.uid) {
      throw new Error(i18n.t('stringSignInBrowserFirst'));
    }

    const nativeStatus = await fetchNativeFiveLoopAccountStatus();
    if (!nativeStatus || nativeStatus.signedIn !== true) {
      throw new Error(i18n.t('stringSignInDesktopFirst'));
    }
    if (!nativeStatus.uid) {
      throw new Error(i18n.t('stringRestartDesktopForAccount'));
    }
    if (nativeStatus.uid !== browserUser.uid) {
      throw new Error(i18n.t('stringDesktopAccountMismatch'));
    }
    return browserUser.uid;
  }

  function showNativeUploadUnavailableOptions() {
    stopNativeFiveLoopLaunchPolling();
    setUploadSongSelectionStepVisible(false);
    $("#file-upload-feedback").find("span").html(
      '<div class="native-upload-unavailable-card">' +
        '<strong>' + i18n.t('stringFiveLoopConnectionFailed') + '</strong>' +
        '<p>' + i18n.t('stringMakeSureFiveLoopOpen') + '</p>' +
        '<div class="native-upload-actions">' +
          '<button type="button" class="button1" id="openNativeFiveLoopBtn"><span>' + i18n.t('stringOpenFiveLoop') + '</span></button>' +
          '<a class="native-upload-download-link" href="' + fiveLoopDownloadURLForCurrentOS() + '" target="_blank" rel="noopener noreferrer">' + fiveLoopDownloadLabelForCurrentOS() + '</a>' +
        '</div>' +
        '<p id="nativeFiveLoopLaunchStatus" aria-live="polite"></p>' +
        '<p class="native-upload-permission-help">' +
          i18n.t('stringAppsOnDevicePermissionHelp') +
        '</p>' +
        '<button type="button" id="serverFallbackProcessingBtn" class="native-upload-server-fallback">' +
          i18n.t('stringServerProcessingFallback') +
        '</button>' +
      '</div>'
    );
  }

  function waitForNativeFiveLoopPoll(milliseconds) {
    return new Promise(function(resolve) {
      setTimeout(resolve, milliseconds);
    });
  }

  async function continueSelectedNativeUpload() {
    if (fileToUpload == null || fileEndingToUpload == "") return;
    stopNativeFiveLoopLaunchPolling();
    closeModal();
    if ($("body").find(".completeOverlay").length === 0) {
      addUploadingOverlay(i18n.t('stringPreparingLocalProcessing'));
    }
    try {
      await uploadSongWithNativeFiveLoop(fileToUpload, fileEndingToUpload, selectedNativeStemModel());
      $("#file").val('');
      resetUploadModal();
    } catch (error) {
      removeUploadingOverlay();
      if (error && String(error.code || '').indexOf('resource-exhausted') !== -1) {
        toggleModal6();
        return;
      }
      alert(error.message || error);
    }
  }

  async function pollNativeFiveLoopAfterLaunch() {
    const pollId = ++nativeFiveLoopLaunchPollId;
    const deadline = Date.now() + FIVELOOP_NATIVE_LAUNCH_POLL_TIMEOUT_MS;
    const button = document.getElementById('openNativeFiveLoopBtn');
    if (button) button.disabled = true;
    $('#nativeFiveLoopLaunchStatus').text(i18n.t('stringWaitingForFiveLoop'));

    await waitForNativeFiveLoopPoll(1000);
    while (pollId === nativeFiveLoopLaunchPollId && Date.now() < deadline) {
      if (!document.getElementById('openNativeFiveLoopBtn') || fileToUpload == null) return;
      const nativeStatus = await checkNativeFiveLoopServer();
      if (pollId !== nativeFiveLoopLaunchPollId) return;
      if (nativeStatus.available) {
        if (nativeStatus.busy) {
          stopNativeFiveLoopLaunchPolling();
          showNativeUploadBusyMessage(nativeStatus);
          return;
        }
        $('#nativeFiveLoopLaunchStatus').text(i18n.t('stringFiveLoopConnected'));
        await continueSelectedNativeUpload();
        return;
      }
      await waitForNativeFiveLoopPoll(FIVELOOP_NATIVE_LAUNCH_POLL_INTERVAL_MS);
    }

    if (pollId === nativeFiveLoopLaunchPollId) {
      const currentButton = document.getElementById('openNativeFiveLoopBtn');
      if (currentButton) currentButton.disabled = false;
      $('#nativeFiveLoopLaunchStatus').text(i18n.t('stringFiveLoopLaunchFailed'));
    }
  }

  $(document).on('click', '#openNativeFiveLoopBtn', function() {
    openFiveLoopExternalURL(fiveLoopOpenURLForCurrentOS());
    pollNativeFiveLoopAfterLaunch();
  });

  $(document).on('click', '#serverFallbackProcessingBtn', async function() {
    if (fileToUpload == null || fileEndingToUpload == "") return;
    stopNativeFiveLoopLaunchPolling();
    closeModal();
    addUploadingOverlay(i18n.t('stringUploadingSongToServer'));
    try {
      await uploadSongToServer(fileToUpload, fileEndingToUpload, selectedNativeStemModel());
    } catch (error) {
      removeUploadingOverlay();
      alert(error.message || error);
    }
  });

  $("#confirmUploadSong").click(async function(){
    if (fileToUpload == null){
      console.log("no file")
      return
    }
    if (fileEndingToUpload == ""){
      console.log("no file format")
      return
    }

    addUploadingOverlay(i18n.t('stringCheckingFiveLoopApp'))

    const nativeStatus = await checkNativeFiveLoopServer();
    if (!nativeStatus.available) {
      removeUploadingOverlay();
      showNativeUploadUnavailableOptions();
      return;
    }
    if (nativeStatus.busy) {
      removeUploadingOverlay();
      showNativeUploadBusyMessage(nativeStatus);
      return;
    }

    await continueSelectedNativeUpload();

  });

  async function enforceServerUploadLimits() {
    const hasPremium = await userHasPremiumCustomClaim();
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const handledSplittingJobsThisMonth = await getDocs(
      collection(db, 'usersReadOnly/' + userId + '/handledSplittingJobs/' + currentYear + '/' + currentMonth)
    );
    const amount = handledSplittingJobsThisMonth.size;

    if (!hasPremium) {
      // Free tier: block after 2
      if (amount > 1) {
        removeUploadingOverlay();
        toggleModal6(); // existing “Get Premium” modal
        return false;
      }
    } else {
      // Premium fair-use: hard stop at 50
      if (amount >= 50) {
        removeUploadingOverlay();
        toggleModal7(); // new modal below
        return false;
      }
      // Premium soft warning at 45–49: show warning but proceed
      if (amount >= 45) {
        const limit = 50;
        const left = limit - amount;
        setFairUseWarningText(amount, limit, left);
        toggleModal8(); // non-blocking; we do not return
      }
    }
    return true;
  }

  async function uploadSongToServer(file, fileEnding, requestedModel) {
    const canUpload = await enforceServerUploadLimits();
    if (!canUpload) return;

    newSongId = doc(collection(db, "globalSongs")).id;

    var fileString = ""
    fileString = file.name

    
    const storageRef = sRef(storage, 'songUploadBucket/'+newSongId+fileEnding);
    const metadata = {
      firebaseStorageDownloadTokens: null,
      contentType: file.type
    };

    await new Promise((resolve, reject) => {
      const uploadTask = uploadBytesResumable(storageRef, file, metadata);

      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          $("#overlaytext").html(Math.round(progress)+'%');
        },
        reject,
        resolve
      );
    });

    $('#overlaytext').text('');
    $("#file").val('');
    removeUploadingOverlay()
    writeSongInDatabase(fileString,fileEnding,requestedModel);
  }

  async function uploadSongWithNativeFiveLoop(file, fileEnding, model) {
    $('#overlaytext2').text(i18n.t('stringCreatingNativeUploadSession'));
    $('#overlaytext').text('');

    const createNativeSongUploadSession = httpsCallable(functions, 'createNativeSongUploadSession');
    const cancelNativeSongUploadSession = httpsCallable(functions, 'cancelNativeSongUploadSession');
    let songId = null;
    let handedOffToNative = false;

    try {
      $('#overlaytext2').text(i18n.t('stringCheckingFiveLoopAccount'));
      const expectedUid = await assertNativeFiveLoopAccountMatchesBrowser();
      $('#overlaytext2').text(i18n.t('stringCreatingNativeUploadSession'));

      const sessionResult = await createNativeSongUploadSession({
        songName: file.name,
        fileEnding: fileEnding,
        requestedModel: model || FIVELOOP_NATIVE_UPLOAD_MODEL,
        nativeApiVersion: FIVELOOP_NATIVE_API_VERSION,
        appVersion: 'web',
        os: detectFiveLoopDesktopOS()
      });

      const session = sessionResult.data || {};
      songId = session.songId;
      if (!songId) throw new Error(i18n.t('stringNativeSessionMissingSongId'));
      if (!session.sessionToken) throw new Error(i18n.t('stringNativeSessionMissingToken'));
      newSongId = songId;

      $('#overlaytext2').text(i18n.t('stringSendingFileToFiveLoop'));
      $('#overlaytext').text('');
      await submitFileToNativeProcessor(songId, file, fileEnding, session.sessionToken, session.functionsBaseURL, expectedUid, model || FIVELOOP_NATIVE_UPLOAD_MODEL);
      handedOffToNative = true;

      $('#overlaytext2').text(i18n.t('stringFiveLoopBackgroundProcessing'));
      $('#overlaytext').text('');
      $("#file").val('');
      removeUploadingOverlay();
    } catch (error) {
      if (songId && !handedOffToNative) {
        try {
          await cancelNativeSongUploadSession({ songId: songId, reason: error.message || 'native upload failed' });
        } catch (cancelError) {}
      }
      throw error;
    }
  }

  async function submitFileToNativeProcessor(songId, file, fileEnding, sessionToken, functionsBaseURL, expectedUid, model) {
    const url = FIVELOOP_NATIVE_SERVER +
      '/cloud-song/process?songId=' + encodeURIComponent(songId) +
      '&fileName=' + encodeURIComponent(file.name) +
      '&fileEnding=' + encodeURIComponent(fileEnding) +
      '&model=' + encodeURIComponent(model || FIVELOOP_NATIVE_UPLOAD_MODEL) +
      '&sessionToken=' + encodeURIComponent(sessionToken || '') +
      '&functionsBaseURL=' + encodeURIComponent(functionsBaseURL || '') +
      '&expectedUid=' + encodeURIComponent(expectedUid || '');
    let response;
    const controller = new AbortController();
    const timeout = setTimeout(function () { controller.abort(); }, 5 * 60 * 1000);
    const slowNotice = setTimeout(function () {
      $('#overlaytext2').text(i18n.t('stringStillSendingFileToFiveLoop'));
    }, 5000);

    try {
      response = await fetch(url, {
        method: 'POST',
        body: file.slice(0, file.size, ''),
        signal: controller.signal
      });
    } catch (error) {
      if (error && error.name === 'AbortError') {
        throw new Error(i18n.t('stringNativeSendTimeout'));
      }
      throw new Error(i18n.t('stringNativeHandoffFailed'));
    } finally {
      clearTimeout(timeout);
      clearTimeout(slowNotice);
    }
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || i18n.t('stringNativeSubmitFailed'));
    }
  }

  $("#goSubscribeBtn").click(function(){
    window.location.href = "subscribe.html"
  })

  function riseLoaderMarkup(extraClass){
    return [
      '<div class="fiveLoopRiseLoader '+ (extraClass || '') +'" aria-label="' + i18n.t('stringProcessingAudio') + '">',
        '<svg viewBox="0 0 320 180" preserveAspectRatio="xMidYMid meet" role="img" aria-hidden="true">',
          '<line class="fiveLoopRiseGuide" x1="16" y1="40" x2="304" y2="40"></line>',
          '<line class="fiveLoopRiseGuide" x1="16" y1="56" x2="304" y2="56"></line>',
          '<line class="fiveLoopRiseGuide" x1="16" y1="72" x2="304" y2="72"></line>',
          '<line class="fiveLoopRiseGuide" x1="16" y1="88" x2="304" y2="88"></line>',
          '<rect class="fiveLoopRiseBar" x="18" y="128" width="10" height="22" rx="3" style="animation-delay:.1s"></rect>',
          '<rect class="fiveLoopRiseBar" x="37" y="120" width="10" height="30" rx="3" style="animation-delay:.5s"></rect>',
          '<rect class="fiveLoopRiseBar" x="56" y="124" width="10" height="26" rx="3" style="animation-delay:.2s"></rect>',
          '<rect class="fiveLoopRiseBar" x="75" y="116" width="10" height="34" rx="3" style="animation-delay:.7s"></rect>',
          '<rect class="fiveLoopRiseBar" x="94" y="126" width="10" height="24" rx="3" style="animation-delay:.3s"></rect>',
          '<rect class="fiveLoopRiseBar" x="113" y="118" width="10" height="32" rx="3" style="animation-delay:.6s"></rect>',
          '<rect class="fiveLoopRiseBar" x="132" y="130" width="10" height="20" rx="3" style="animation-delay:.15s"></rect>',
          '<rect class="fiveLoopRiseBar" x="151" y="122" width="10" height="28" rx="3" style="animation-delay:.45s"></rect>',
          '<rect class="fiveLoopRiseBar" x="170" y="120" width="10" height="30" rx="3" style="animation-delay:.25s"></rect>',
          '<rect class="fiveLoopRiseBar" x="189" y="126" width="10" height="24" rx="3" style="animation-delay:.65s"></rect>',
          '<rect class="fiveLoopRiseBar" x="208" y="116" width="10" height="34" rx="3" style="animation-delay:.35s"></rect>',
          '<rect class="fiveLoopRiseBar" x="227" y="124" width="10" height="26" rx="3" style="animation-delay:.05s"></rect>',
          '<rect class="fiveLoopRiseBar" x="246" y="120" width="10" height="30" rx="3" style="animation-delay:.55s"></rect>',
          '<rect class="fiveLoopRiseBar" x="265" y="128" width="10" height="22" rx="3" style="animation-delay:.4s"></rect>',
          '<rect class="fiveLoopRiseBar" x="284" y="122" width="10" height="28" rx="3" style="animation-delay:.2s"></rect>',
          '<rect class="fiveLoopRiseNote" x="40" y="72" width="16" height="9" rx="3" style="animation-delay:.1s"></rect>',
          '<rect class="fiveLoopRiseNote" x="78" y="40" width="16" height="9" rx="3" style="animation-delay:.7s"></rect>',
          '<rect class="fiveLoopRiseNote" x="118" y="52" width="16" height="9" rx="3" style="animation-delay:1.3s"></rect>',
          '<rect class="fiveLoopRiseNote" x="150" y="84" width="16" height="9" rx="3" style="animation-delay:.4s"></rect>',
          '<rect class="fiveLoopRiseNote" x="196" y="52" width="16" height="9" rx="3" style="animation-delay:1.0s"></rect>',
          '<rect class="fiveLoopRiseNote" x="236" y="36" width="16" height="9" rx="3" style="animation-delay:1.6s"></rect>',
          '<rect class="fiveLoopRiseNote" x="272" y="68" width="16" height="9" rx="3" style="animation-delay:.85s"></rect>',
        '</svg>',
      '</div>'
    ].join('');
  }

  function addUploadingOverlay(message){
    $("body").prepend(
      '<div class="completeOverlay">' + riseLoaderMarkup('fiveLoopRiseLoaderOverlay') +
        '<p id="overlaytext2">'+ (message || i18n.t('stringUploadingSong')) +'</p>' +
        '<p id="overlaytext"></p>' +
      '</div>'
    );
  }
  
  function removeUploadingOverlay(){
    $("body").find(".completeOverlay").hide().remove();
  }

  function resetUploadModal(){
    stopNativeFiveLoopLaunchPolling();
    setUploadSongSelectionStepVisible(true);
    $("#drop-zone-occupied").addClass('hidedisplay');
    $("#drop-zone").removeClass('hidedisplay');
    $("#drop-zone-filename").find("span").html("")
    $("#drop-zone-filemetadata").find("span").html("")
    $("#file-upload-feedback").find("span").html('')
    fileToUpload = null
    fileEndingToUpload = ""
    const defaultStemModel = document.querySelector('input[name="nativeStemModel"][value="' + FIVELOOP_NATIVE_UPLOAD_MODEL + '"]');
    if (defaultStemModel) defaultStemModel.checked = true;
  }

  $("#close-drop-zone-occupied").click(function(){
    resetUploadModal()
  });

  function writeSongInDatabase(songName,fileEnding,requestedModel){

    var dateAndTime = Math.round(new Date().getTime()/1000)
    const normalizedRequestedModel = requestedModel === 'htdemucs'
      ? 'htdemucs'
      : 'htdemucs_6s';

    const data = {
      songName: songName,
      fromUser: userId,
      creationDate: dateAndTime,
      songId: newSongId,
      fileEnding: fileEnding
    };
    const splittingJobData = {
      ...data,
      requestedModel: normalizedRequestedModel
    };

    const songRef = doc(db, 'usersSplittingJobs/' + newSongId);
    setDoc(songRef, splittingJobData)
    .then(() => {
      // Data saved successfully!
      const userSongRef = doc(db, 'users/' + userId + '/songs', newSongId);
      setDoc(userSongRef, data)
      .then(() => {
        // Data saved successfully!
      })
      .catch((error) => {
        alert(error.message);
      });
    })
    .catch((error) => {
      alert(error.message);
    });


}

//MARK: SongListener

var songListenerRef
var selectedPlaylist = ""

async function songListener(){

  console.log("paginationArray.length: "+paginationArray.length)

  if (typeof songListenerRef !== "undefined"){
    songListenerRef()
  }

  const searchValue = $('#inputSearch').val().toUpperCase()
  const searchArray = searchValue.split(' ')

  const songsRef = collection(db, 'users/' + userId + '/songs');
  var q
  if (searchValue != ""){

    q = query(songsRef, where("queryArray", "array-contains-any", searchArray), limit(resultsPerPage));
    addLoadingOverlay()
    const querySnapshot = await getDocs(q);
    removeLoadingOverlay()
    handleQuerySnapshot(querySnapshot)
    document.getElementById("pagination").style.opacity = 0;
    return
  } else {
    if (paginationArray.length == 0){
      if (selectedPlaylist == "") {
        q = query(songsRef, orderBy("creationDate", "desc"), limit(resultsPerPage));
      } else {
        q = query(songsRef, where("inPlaylist", "array-contains", selectedPlaylist), orderBy("creationDate", "desc"), limit(resultsPerPage));
        addLoadingOverlay()
        const querySnapshot = await getDocs(q);
        removeLoadingOverlay()
        //paginationArray[paginationArray.length] = querySnapshot.docs[querySnapshot.docs.length - 1]
        const newLastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];
        const lastPaginationDoc = paginationArray.length > 0 ? paginationArray[paginationArray.length - 1] : null;
        if (!lastPaginationDoc || (newLastDoc && newLastDoc.id !== lastPaginationDoc.id)) {
          paginationArray.push(newLastDoc);
        }
        handleQuerySnapshot(querySnapshot)
        return
      }
    } else {
      if (selectedPlaylist == "") {
        q = query(songsRef, orderBy("creationDate", "desc"), startAfter(paginationArray[paginationArray.length - 1]), limit(resultsPerPage));
      } else {
        q = query(songsRef, where("inPlaylist", "array-contains", selectedPlaylist), orderBy("creationDate", "desc"), startAfter(paginationArray[paginationArray.length - 1]), limit(resultsPerPage));
      }
      
    }
  }
  addLoadingOverlay()
  songListenerRef = onSnapshot(q, (snapshot) => {
    removeLoadingOverlay()
    if (snapshot.empty) {
      console.log("No documents found.");
      return
    }
    //paginationArray[paginationArray.length] = snapshot.docs[snapshot.docs.length - 1]
    const newLastDoc = snapshot.docs[snapshot.docs.length - 1];
    const lastPaginationDoc = paginationArray.length > 0 ? paginationArray[paginationArray.length - 1] : null;
    if (!lastPaginationDoc || (newLastDoc && newLastDoc.id !== lastPaginationDoc.id)) {
      paginationArray.push(newLastDoc);
    }
    handleQuerySnapshot(snapshot)
  });

}

function handleQuerySnapshot(querySnapshot){
  $("#songsTable").find("tr").remove();
  querySnapshot.forEach((snap) => {
    var songId = snap.data().songId
    var fromUser = snap.data().fromUser
    var songName = snap.data().songName
    var stems = snap.data().stems
    var processingStatus = snap.data().processingStatus
    var creationDate = snap.data().creationDate
    var stemString = ''
    var songtd = '<td class="tdsongname draggable" draggable="true">'+ songName + '</td>'
    var stemsAreReady = stems != null && [
      'analysisPending',
      'stemsReady',
      'analysisRunning'
    ].includes(processingStatus)
    var isProcessing = stems == null || (processingStatus != null && processingStatus !== 'ready' && !stemsAreReady)
    if (isProcessing){
      stemString = '<i class="fa fa-circle-o-notch fa-spin"></i><span>' + i18n.t('stringProcessing') + '</span>'
      songtd = '<td class="tdsongname halfopacity">'+ songName + '</td>'
    } else if (stemsAreReady) {
      stemString = '<i class="fa fa-circle-o-notch fa-spin"></i><span>' + i18n.t('stringAnalyzing') + '</span>'
    }

    const dropdowndiv = '<div class="dropdown2-content">' +
                          '<div class="dropdown2-content-item item-editname">' +
                            '<img src="src/icon_edit.png"></img>' +
                            '<a>'+i18n.t('stringRename')+'</a>' +
                          '</div>' +
                          '<div class="dropdown2-content-item item-removecache">' +
                            '<img src="src/icon_storage.png"></img>' +
                            '<a>'+i18n.t('stringRemoveFromCache')+'</a>' +
                          '</div>' +
                          '<div class="dropdown2-content-item item-removefromplaylist">' +
                            '<img src="src/icon_list.png"></img>' +
                            '<a>'+i18n.t('stringRemoveFromPlaylist')+'</a>' +
                          '</div>' +
                          '<div class="dropdown2-content-item item-remove">' +
                            '<img src="src/icon_remove.png"></img>' +
                            '<a>'+i18n.t('stringRemove')+'</a>' +
                          '</div>' +
                        '</div>'

    $("#songsTable").append('<tr id="'+ songId +'" creationdate="'+ creationDate +'">'+ songtd + '<td class="stemtd halfopacity">'+ stemString +'</td><td class="tdstorage hovertext2 hidedisplay" data-hover="'+i18n.t('stringStoredInCacheInfo')+'"><img src="src/icon_storage.png"></img></td><td class="tdmore"><img src="src/icon_more2.png"></img>'+dropdowndiv+'</td>')

  });
  var colCount = $("#songsTable tr").length;
  if (colCount == 0 && selectedPlaylist != "" && paginationArray.length < 2){
    addPlaylistHowToOverlay()
    updatePaginationUi()
  } else {
    removePlaylistHowToOverlay()
    addDraggableEventListeners()
    updatePaginationUi()
    checkSongsInIndexedDb()
  }
  
}


$("#songsTable").on("click", "td", function() {
  let id = $(this).closest('tr').attr('id');
  if ($(this).hasClass("tdsongname")){
    if ($(this).hasClass("halfopacity")){
      return
    }
    window.location.href = 'player.html?songid='+id;
  } else if ($(this).hasClass('tdmore')){
    if($(this).closest('tr').find('td.tdstorage').hasClass("hidedisplay")){
      $(this).find('.item-removecache').addClass("hidedisplay")
    } else {
      $(this).find('.item-removecache').removeClass("hidedisplay")
    }
    if(selectedPlaylist == ""){
      $(this).find('.item-removefromplaylist').addClass("hidedisplay")
    } else {
      $(this).find('.item-removefromplaylist').removeClass("hidedisplay")
    }
    $(this).find('.dropdown2-content').toggleClass("dropdown2show");
    $("#songsTable").find("tr").not($(this).closest('tr')).toggleClass("disabledandalmosthidden")
  }
  
});

$("#songsTable").on("click", "div", function() {
  let id = $(this).closest('tr').attr('id');
  if ($(this).hasClass("item-editname")){
    const currentName = $(this).closest('tr').find('td.tdsongname').html()
    toggleModal4(id,currentName)
  } else if ($(this).hasClass('item-removecache')){
    removeSongFromCache(id)
  } else if ($(this).hasClass('item-remove')){
    removeSongFromFirestore(id)
  } else if ($(this).hasClass('item-removefromplaylist')){
    removeSongFromPlaylist(id)
  }
})

//MARK: Pagination

var paginationArray = []

$("#pagination_start").click(function(){
  if (document.getElementById("pagination_start").style.opacity == 0) {
    return
  }
  paginationArray = []
  songListener()
});

$("#pagination_back").click(function(){
  if (document.getElementById("pagination_back").style.opacity == 0) {
    return
  }
  if (paginationArray.length > 0){
    paginationArray.splice(-2)
    songListener()
  }
});

$("#pagination_forward").click(function(){
  if (document.getElementById("pagination_forward").style.opacity == 0) {
    return
  }
  if (typeof $('#songsTable tr:last').attr("creationdate") == "undefined"){
    return
  }
  songListener()
});



function updatePaginationUi(){
  var tbodyRowCount = document.getElementById("songsTable").tBodies[0].rows.length;
  document.getElementById("pagination_current").getElementsByTagName( 'span' )[0].innerHTML = paginationArray.length
  pagination_current
  if (paginationArray.length == 1 && tbodyRowCount == resultsPerPage){
    document.getElementById("pagination").style.opacity = 1;
    document.getElementById("pagination_start").style.opacity = 0;
    document.getElementById("pagination_back").style.opacity = 0;
    document.getElementById("pagination_forward").style.opacity = 1;
  } else if (paginationArray.length == 1 && tbodyRowCount < resultsPerPage){
    document.getElementById("pagination").style.opacity = 0;
  } else if (paginationArray.length == 2 && tbodyRowCount == resultsPerPage){
    document.getElementById("pagination").style.opacity = 1;
    document.getElementById("pagination_start").style.opacity = 0;
    document.getElementById("pagination_back").style.opacity = 1;
    document.getElementById("pagination_forward").style.opacity = 1;
  }  else if (paginationArray.length > 2 && tbodyRowCount == resultsPerPage){
    document.getElementById("pagination").style.opacity = 1;
    document.getElementById("pagination_start").style.opacity = 1;
    document.getElementById("pagination_back").style.opacity = 1;
    document.getElementById("pagination_forward").style.opacity = 1;
  } else if (paginationArray.length > 1 && tbodyRowCount < resultsPerPage){
    document.getElementById("pagination").style.opacity = 1;
    document.getElementById("pagination_start").style.opacity = 1;
    document.getElementById("pagination_back").style.opacity = 1;
    document.getElementById("pagination_forward").style.opacity = 0;
  }
}

//MARK: Search

var timer = null;
$('#inputSearch').keyup(function(){
  clearTimeout(timer); 
  timer = setTimeout(songListener, 1000)
});


$("#playlistTable").on("click", "tr", function() {
  let id = $(this).attr('id');

  if (id == "addPlaylistBtn"){
    toggleModal3()
  } else if (id == "allSongsBtn"){
    if($(this).hasClass("selectedplaylist")){
      return
    }
    selectedPlaylist = ""
    paginationArray = []
    $("#playlistTable").find(".selectedplaylist").removeClass("selectedplaylist");
    $(this).addClass("selectedplaylist");
    document.getElementById("listtitelheader").innerHTML = i18n.t('stringAllSongs')
    $("#listtitelMoreImg").addClass("hidedisplay"); 
    $('#inputSearch').removeClass("hidedisplay")
    songListener()
  } else {
    if($(this).hasClass("selectedplaylist")){
      return
    }
    selectedPlaylist = id
    paginationArray = []
    $("#playlistTable").find(".selectedplaylist").removeClass("selectedplaylist");
    $(this).addClass("selectedplaylist");
    document.getElementById("listtitelheader").innerHTML = $(this).find(".playlisttitle").text()
    $("#listtitelMoreImg").removeClass("hidedisplay");  
    $('#inputSearch').val("")
    $('#inputSearch').addClass("hidedisplay")
    songListener()
  }

});

//MARK: Playlist

// Get the modal
var modal3 = document.getElementById("myModal3");
// Get the <span> element that closes the modal
var span3 = document.getElementsByClassName("close3")[0];
// When the user clicks on <span> (x), close the modal
span3.onclick = function() {
  closeModal3()
}
function closeModal3(){
  modal3.style.display = "none";
}
function toggleModal3() {
  document.getElementById("inputPlaylist").value = ""
  modal3.style.display = "block";
  document.getElementById("inputPlaylist").focus()
}

$("#createPlaylistBtn").click(function(){

  var dateAndTime = Math.round(new Date().getTime()/1000)

  if ($('#inputPlaylist').val() == ""){
    return
  }

  $("#createPlaylistBtn").addClass("halfopacity");
  $("#createPlaylistBtn").find('i').first().removeClass("hidedisplay");
  $("#createPlaylistBtn").find('span').first().addClass("hidedisplay");

  const playlistName = $('#inputPlaylist').val()

  const data = {
    playlistName: playlistName,
    creationDate: dateAndTime
  };

  const newPlaylistId = doc(collection(db, 'users/' + userId + '/playlists')).id;

  const userPlaylistRef = doc(db, 'users/' + userId + '/playlists', newPlaylistId);
  setDoc(userPlaylistRef, data)
  .then(() => {
    // Data saved successfully!
    $("#createPlaylistBtn").removeClass("halfopacity");
    $("#createPlaylistBtn").find('i').first().addClass("hidedisplay");
    $("#createPlaylistBtn").find('span').first().removeClass("hidedisplay");
    closeModal3()
  })
  .catch((error) => {
    $("#createPlaylistBtn").removeClass("halfopacity");
    $("#createPlaylistBtn").find('i').first().addClass("hidedisplay");
    $("#createPlaylistBtn").find('span').first().removeClass("hidedisplay");
    alert(error.message);

  });
});

function playlistListener(){
  const playlistsRef = collection(db, 'users/' + userId + '/playlists');
  const q = query(playlistsRef, orderBy("creationDate", "desc"), limit(resultsPerPage));
  const playlistListenerRef = onSnapshot(q, (snapshot) => {
    // keep first two rows
    $("#playlistTable").find("tr:not(:lt(2))").remove();
    snapshot.docs.forEach(function(snap){
      var playlistId = snap.id
      var playlistName = snap.data().playlistName
      var creationDate = snap.data().creationDate

      $("#playlistTable").append('<tr id="'+ playlistId +'" class="dropable"><td><img src="src/icon_list.png"></img></td><td><i class="fa fa-circle-o-notch fa-spin hidedisplay"></i><span class="playlisttitle">'+ playlistName + '</span></td>')
    })
    if (selectedPlaylist != ""){
      $("#"+selectedPlaylist).addClass("selectedplaylist");
    }
    addOnDropEventListeners()
  });
}

//MARK: Dragging Songs to Playlist

function addDraggableEventListeners() {
  const draggables = document.querySelectorAll(".draggable")
  draggables.forEach(draggable => {
    draggable.addEventListener("dragstart", () => {
      draggable.classList.add("dragging")
    });
    draggable.addEventListener("dragend", () => {
      counter = 0
      draggable.classList.remove("dragging")
    });
  });

}

var counter = 0

function addOnDropEventListeners() {
  const dropables = document.querySelectorAll(".dropable")
  dropables.forEach(dropable => {
    dropable.addEventListener("dragover", e => {
      e.preventDefault()
    });
    dropable.addEventListener("dragenter", e => {
      const olddropable = document.querySelector(".readyfordrop")
      if (olddropable !== null){
        olddropable.classList.remove("readyfordrop")
      }
      dropable.classList.add("readyfordrop")
      counter++
    });
    dropable.addEventListener("dragleave", e => {
      counter--
      if(counter === 0){
        dropable.classList.remove("readyfordrop")
      }
    });
    dropable.addEventListener("drop", e => {
      counter = 0
      dropable.classList.remove("readyfordrop")
      const draggable = document.querySelector(".dragging")
      let songId = $(draggable).closest('tr').attr('id');
      let playlistId = $(dropable).attr('id');
      putSongInPlaylist(songId,playlistId,dropable)
    });
  });
}

function putSongInPlaylist(songId,playlistId,dropable){

  $(dropable).addClass("halfopacity");
  $(dropable).children('td').eq(1).find('i').first().removeClass("hidedisplay");
  $(dropable).children('td').eq(1).find('span').first().addClass("hidedisplay");

  const userSongRef = doc(db, 'users/' + userId + '/songs', songId);
  updateDoc(userSongRef, {
    inPlaylist: arrayUnion(playlistId)
  })
  .then(() => {
    // Data saved successfully!
    $(dropable).removeClass("halfopacity");
    $(dropable).children('td').eq(1).find('i').first().addClass("hidedisplay");
    $(dropable).children('td').eq(1).find('span').first().removeClass("hidedisplay");
  })
  .catch((error) => {
    alert(error.message);
  });

}

function addLoadingOverlay(){
  $(".songsContainer").prepend(
    '<div class="songsOverlay"><div class="lds-ring"><div></div><div></div><div></div><div></div></div>' +
    '</div>'
  );
}

function removeLoadingOverlay(){
  $(".songsContainer").find(".songsOverlay").hide().remove();
}

function addPlaylistHowToOverlay(){
  $(".songsContainer").prepend(
    '<div class="songsOverlayPlaylist"><div class="playlistHowTo"><span>'+i18n.t('stringPlaylistHowTo')+'</span><img src="src/playlist_howto.png"></img></div>' +
    '</div>'
  );
}

function removePlaylistHowToOverlay(){
  $(".songsContainer").find(".songsOverlayPlaylist").hide().remove();
}

//MARK: IndexedDB

function checkSongsInIndexedDb(){
  const request = indexedDB.open("songs", 1);
  request.onerror = function (event) {
    console.error("An error occurred with IndexedDB");
    console.error(event);
  };

  request.onupgradeneeded = function () {
    //1
    const db = request.result;
    //2
    const store = db.createObjectStore("audiofiles", { keyPath: "id" });
    const store2 = db.createObjectStore("sizeInBytes", { keyPath: "id" });
  };

  request.onsuccess = async function () {

    const db = request.result;

    const transaction = db.transaction("audiofiles", "readwrite");
    const store = transaction.objectStore("audiofiles");
    const itemsRequest = await store.getAllKeys()

    // Handle the success case
    itemsRequest.onsuccess = function(event) {
      // Get the result of the request
      var items = event.target.result;
      items.forEach((item) => {
        if ($('#'+item).length > 0) {
          $('#'+item).find('td.tdstorage').removeClass("hidedisplay")
        }
      })
    };

    transaction.oncomplete = function () {
      db.close();
    };

    const transaction2 = db.transaction("sizeInBytes", "readwrite");
    const store2 = transaction2.objectStore("sizeInBytes");
    const sizeItemsRequest = await store2.getAll()

    // Handle the success case
    sizeItemsRequest.onsuccess = function(event) {
      // Get the result of the request
      var sizeInBytes = 0
      var items = event.target.result;
      items.forEach((item) => {
        sizeInBytes = sizeInBytes + item.total
      })
      const sizeInMegabytes = sizeInBytes / 1048576; // convert the size to megabytes
      const roundedSizeInMegabytes = Math.round(sizeInMegabytes)
      $('#storageusage').find('span').html(i18n.t('stringStorageUsage1')+' <b>'+roundedSizeInMegabytes+'MB</b> '+i18n.t('stringStorageUsage2')+' <a href="storage.html">'+i18n.t('stringStorageUsage3')+'</a>')
      if (roundedSizeInMegabytes > 0){
        $('#storageusage').removeClass("hidedisplay")
      }
      
      
    };

    transaction2.oncomplete = function () {
      db.close();
    };

    
  }
  
}

function visibilitychangeFunction() {
  if (document.hidden) {
    // The page is hidden
  } else {
    // The page is visible
    checkSongsInIndexedDb()
  }
}

document.addEventListener("visibilitychange", visibilitychangeFunction);

function removeSongFromCache(id){

  const request = indexedDB.open("songs", 1);
  request.onerror = function (event) {
    console.error("An error occurred with IndexedDB");
    console.error(event);
  };

  request.onsuccess = async function () {

    const db = request.result;

    const transaction = db.transaction("audiofiles", "readwrite");
    const store = transaction.objectStore("audiofiles");
    const deleteSong = store.delete(id);

    deleteSong.onsuccess = function () {
      //console.log("Song ",id ," has been removed from audiofiles");
    };

    transaction.oncomplete = function () {
      db.close();
    };

    const transaction2 = db.transaction("sizeInBytes", "readwrite");
    const store2 = transaction2.objectStore("sizeInBytes");
    const deleteSong2 = store2.delete(id);

    deleteSong2.onsuccess = function () {
      //console.log("Song ",id ," has been removed from size");
    };

    transaction2.oncomplete = function () {
      db.close();
      $('#'+id).find('td.tdstorage').addClass("hidedisplay")
      checkSongsInIndexedDb()
    };


    
  }

}

function removeSongFromFirestore(id){
  const userSongRef = doc(db, 'users/' + userId + '/songs', id);
  deleteDoc(userSongRef)
  .then(() => {
    // Data removed successfully!
    removeSongFromCache(id)
    const searchValue = $('#inputSearch').val().toUpperCase()
    if (searchValue != "" || selectedPlaylist != ""){
      songListener()
    }
    
  })
  .catch((error) => {
    alert(error.message);
  });
}

// Get the modal
var modal4 = document.getElementById("myModal4");
// Get the <span> element that closes the modal
var span4 = document.getElementsByClassName("close4")[0];
// When the user clicks on <span> (x), close the modal
span4.onclick = function() {
  closeModal4()
}
function closeModal4(){
  modal4.style.display = "none";
}
function toggleModal4(id,currentName) {
  document.getElementById("inputRenameSong").value = ""
  document.getElementById("inputRenameSong").placeholder = currentName
  renameSongElementId = id
  modal4.style.display = "block";
  document.getElementById("inputRenameSong").focus()
}

var renameSongElementId = ""

$("#renameSongBtn").click(function(){
  if (renameSongElementId == ""){
    return
  }
  var newSongName = document.getElementById("inputRenameSong").value
  if (newSongName == ""){
    return
  }
  $("#renameSongBtn").addClass("halfopacity");
  $("#renameSongBtn").find('i').first().removeClass("hidedisplay");
  $("#renameSongBtn").find('span').first().addClass("hidedisplay");
  const userSongRef = doc(db, 'users/' + userId + '/songs', renameSongElementId);
  updateDoc(userSongRef, {
    songName: newSongName
  })
  .then(() => {
    // Data saved successfully!
    $("#renameSongBtn").removeClass("halfopacity");
    $("#renameSongBtn").find('i').first().addClass("hidedisplay");
    $("#renameSongBtn").find('span').first().removeClass("hidedisplay");
    closeModal4()
    const searchValue = $('#inputSearch').val().toUpperCase()
    if (searchValue != "" || selectedPlaylist != ""){
      songListener()
    }
  })
  .catch((error) => {
    $("#renameSongBtn").removeClass("halfopacity");
    $("#renameSongBtn").find('i').first().addClass("hidedisplay");
    $("#renameSongBtn").find('span').first().removeClass("hidedisplay");
    alert(error.message);
  });

})

$("#listtitelMoreImg").click(function(){
  $("#listtitelMoreContent").toggleClass("dropdown3show");
})

$("#openRenamePlaylistBtn").click(function(){
  const currentName = $("#listtitelheader").html()
  toggleModal5(selectedPlaylist,currentName)
})

$("#removePlaylistBtn").click(function(){
  if (selectedPlaylist == ""){
    return
  }
  addLoadingOverlay()
  const userPlaylistRef = doc(db, 'users/' + userId + '/playlists', selectedPlaylist);
  deleteDoc(userPlaylistRef)
  .then(() => {
    // Data removed successfully!
    removeLoadingOverlay()
    selectedPlaylist = ""
    paginationArray = []
    $("#allSongsBtn").addClass("selectedplaylist");
    document.getElementById("listtitelheader").innerHTML = i18n.t('stringAllSongs')
    $("#listtitelMoreImg").addClass("hidedisplay");
    songListener()
    playlistListener()
  })
  .catch((error) => {
    removeLoadingOverlay()
    alert(error.message);
  });
})

// Get the modal
var modal5 = document.getElementById("myModal5");
// Get the <span> element that closes the modal
var span5 = document.getElementsByClassName("close5")[0];
// When the user clicks on <span> (x), close the modal
span5.onclick = function() {
  closeModal5()
}
function closeModal5(){
  modal5.style.display = "none";
}
function toggleModal5(id,currentName) {
  document.getElementById("inputRenamePlaylist").value = ""
  document.getElementById("inputRenamePlaylist").placeholder = currentName
  renamePlaylistElementId = id
  modal5.style.display = "block";
  document.getElementById("inputRenamePlaylist").focus()
}

// Get the modal
var modal6 = document.getElementById("myModal6");
// Get the <span> element that closes the modal
var span6 = document.getElementsByClassName("close6")[0];
// When the user clicks on <span> (x), close the modal
span6.onclick = function() {
  closeModal6()
}
function closeModal6(){
  modal6.style.display = "none";
}
function toggleModal6() {
  modal6.style.display = "block";
}

// Get the modal
var modal7 = document.getElementById("myModal7");
// Close handlers
var span7 = document.getElementsByClassName("close7")[0];
span7.onclick = function() { closeModal7(); }
function closeModal7(){ modal7.style.display = "none"; }
function toggleModal7() { modal7.style.display = "block"; }

document.getElementById("closeFiftySongsLimitBtn").addEventListener("click", closeModal7);

// Soft warning modal (45–49)
var modal8 = document.getElementById("myModal8");
var span8 = document.getElementsByClassName("close8")[0];

function closeModal8(){ modal8.style.display = "none"; }
function toggleModal8(){ modal8.style.display = "block"; }

span8.onclick = function() { closeModal8(); };
document.getElementById("closeFairUseWarningBtn").addEventListener("click", closeModal8);

function setFairUseWarningText(count, limit, left) {
  const txt = i18n.t('stringFairUseWarningDetail', { count, limit, left });
  document.getElementById('fairUseWarningText').innerHTML = txt;
}

var renamePlaylistElementId = ""

$("#renamePlaylistBtn").click(function(){
  if (renamePlaylistElementId == ""){
    return
  }
  var newPlaylistName = document.getElementById("inputRenamePlaylist").value
  if (newPlaylistName == ""){
    return
  }
  $("#renamePlaylistBtn").addClass("halfopacity");
  $("#renamePlaylistBtn").find('i').first().removeClass("hidedisplay");
  $("#renamePlaylistBtn").find('span').first().addClass("hidedisplay");
  const userPlaylistRef = doc(db, 'users/' + userId + '/playlists', renamePlaylistElementId);
  updateDoc(userPlaylistRef, {
    playlistName: newPlaylistName
  })
  .then(() => {
    // Data saved successfully!
    document.getElementById("listtitelheader").innerHTML = newPlaylistName
    $("#renamePlaylistBtn").removeClass("halfopacity");
    $("#renamePlaylistBtn").find('i').first().addClass("hidedisplay");
    $("#renamePlaylistBtn").find('span').first().removeClass("hidedisplay");
    closeModal5()
    playlistListener()
  })
  .catch((error) => {
    $("#renamePlaylistBtn").removeClass("halfopacity");
    $("#renamePlaylistBtn").find('i').first().addClass("hidedisplay");
    $("#renamePlaylistBtn").find('span').first().removeClass("hidedisplay");
    alert(error.message);
  });

})

function removeSongFromPlaylist(songId){
  if (selectedPlaylist == ""){
    return
  }
  if (songId == ""){
    return
  }
  addLoadingOverlay()
  const userSongRef = doc(db, 'users/' + userId + '/songs', songId);
  updateDoc(userSongRef, {
    inPlaylist: arrayRemove(selectedPlaylist)
  })
  .then(() => {
    // Data saved successfully!
    removeLoadingOverlay()
    songListener()
  })
  .catch((error) => {
    removeLoadingOverlay()
    alert(error.message);
  });

}
